export const IS_DEV = process.env.NODE_ENV === "development" || false;

export const persistPrefix = "persist:";

export const breakpoints = {
  xs: "36em",
  sm: "48em",
  md: "62em",
  lg: "72em",
  xl: "88em",
};

export const BACKEND_URL = process.env.REACT_APP_API_URL;

export const API_URL = BACKEND_URL + "/api";

export const MENU_WIDTH = 270;

export const BASE_BORDER_RADIUS = 120;

export const BASE_ACTIVE_ITEM_COLOR = "#00A99D";

export const BASE_HOVER_ITEM_COLOR = "rgb(37, 38, 43)";
